import request from '@/utils/request'
/**
 *
 * 抽奖管理
 *
 **/

// 查询列表数据
export const getDrawPage = (params: any) => {
  return request({
    url: '/admin/draw/page',
    method: 'get',
    params,
  },)
}

// 删除数据接口
export const deleteDraw = (ids: string) => {
  return request({
    url: '/admin/draw',
    method: 'delete',
    params: { ids }
  })
}

// 修改数据接口
export const editDraw = (params: any) => {
  return request({
    url: '/admin/draw',
    method: 'put',
    data: { ...params }
  })
}

// 新增数据接口
export const addDraw = (params: any) => {
  return request({
    url: '/admin/draw',
    method: 'post',
    data: { ...params }
  })
}

// 查询详情接口
export const queryDrawById = (id: string) => {
  return request({
    url: `/admin/draw/${id}`,
    method: 'get'
  })
}

// 批量起售禁售
export const drawStatusByStatus = (params: any) => {
  return request({
    url: `/admin/draw/status/${params.status}`,
    method: 'post',
    params: { id: params.ids }
  })
}

//商品分类数据查询
export const drawCategoryList = (params: any) => {
  return request({
    url: `/admin/category/list`,
    method: 'get',
    params: { ...params }
  })
}

// 获取抽奖关联的奖品列表
export const getDrawPrizesByDrawId = (drawId: string) => {
  return request({
    url: `/admin/draw/listPrizes/${drawId}`,
    method: 'get'
  })
}
